import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const initialState = {};
export const zigbeeNodeNeighborsSlice = createSlice({
    name: 'zigbee_node_neighbors',
    initialState,
    reducers: {
        zigbeeNodeNeighborsCleared: s => {
            for (const key in s) {
                delete s[key];
            }
            ;
        },
        zigbeeNodeNeighborUpdated: (s, action) => {
            s[action.payload.node_id] = action.payload.neighbors;
        },
        zigbeeNodeNeighborDeleted: (s, action) => {
            delete s[action.payload];
        },
        zigbeeNodeNeighborsReplaced: (s, action) => {
            return action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(setDefinitions, (s, action) => {
            const newState = {};
            for (const zigbeeNode of action.payload.zigbee_nodes) {
                const neighbors = zigbeeNode.moved_to_own_slice_neighbors;
                if (neighbors !== undefined) {
                    newState[zigbeeNode.id] = neighbors;
                }
            }
            return newState;
        });
    },
});
export const { zigbeeNodeNeighborsCleared, zigbeeNodeNeighborUpdated, zigbeeNodeNeighborDeleted, zigbeeNodeNeighborsReplaced } = zigbeeNodeNeighborsSlice.actions;
export default zigbeeNodeNeighborsSlice.reducer;
